import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import 'leaflet-lasso';
import * as L from 'leaflet';
import { BehaviorSubject } from 'rxjs';
import { EditableMapService } from '@map/services/editable-map.service';

@Component({
    selector: 'app-draw-line-control',
    templateUrl: 'draw-line.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DrawLineComponent {
    @Input()
    map: L.Map;

    active$ = new BehaviorSubject(false);

    constructor(private editableMapService: EditableMapService) {}

    start() {
        this.active$.next(true);
        this.editableMapService.startLineDrawing();
        this.map.on('editable:drawing:end', this.end, this);
        this.map.on('editable:drawing:commit', this.end, this);
    }

    end() {
        this.active$.next(false);
    }
}
